import { CardAccountPhoneIcon } from './CardAccountPhoneIcon';

/**
 * author: Google
 * id D992EB08-7BDB-4D44-B3C1-A123F80C17FA
 * name card-account-phone
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-phone.svg
 * tags
 * - Account / User 
 */
export const ContactPhoneIcon = CardAccountPhoneIcon;
export default ContactPhoneIcon